export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/AiNumberReader.worker.38e17b72.worker.js");
}
